/**
 * Shared inline styles for admin pages.
 * Keeps page files under 300 lines by extracting common patterns.
 */

export const section: React.CSSProperties = { marginBottom: 32 };

export const sectionTitle: React.CSSProperties = {
  fontSize: 16,
  fontWeight: 600,
  marginBottom: 12,
};

export const cardGrid: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
  gap: 12,
};

export const card: React.CSSProperties = {
  padding: 16,
  border: "1px solid var(--color-border)",
  borderRadius: 8,
  background: "var(--color-bg)",
};

export const cardLabel: React.CSSProperties = {
  fontSize: 13,
  color: "var(--color-text-secondary)",
  fontWeight: 500,
};

export const badge: React.CSSProperties = {
  display: "inline-block",
  padding: "2px 8px",
  borderRadius: 12,
  fontSize: 11,
  fontWeight: 600,
  color: "#ffffff",
  textTransform: "uppercase",
  letterSpacing: "0.04em",
};

export const refreshBtn: React.CSSProperties = {
  padding: "6px 14px",
  fontSize: 13,
  fontWeight: 500,
  borderRadius: 6,
  border: "1px solid var(--color-border)",
  background: "var(--color-bg)",
  color: "var(--color-text)",
};

export const errorBanner: React.CSSProperties = {
  padding: "8px 12px",
  marginBottom: 16,
  borderRadius: 6,
  background: "var(--color-danger-bg)",
  color: "var(--color-danger)",
  fontSize: 13,
};

export const loadingText: React.CSSProperties = {
  fontSize: 14,
  color: "var(--color-text-secondary)",
};

export const bigNumber: React.CSSProperties = {
  display: "block",
  fontSize: 28,
  fontWeight: 700,
  fontFamily: "var(--font-mono)",
};

export const skeleton: React.CSSProperties = {
  background:
    "linear-gradient(90deg, var(--color-border) 25%, transparent 50%, var(--color-border) 75%)",
  backgroundSize: "200% 100%",
  animation: "shimmer 1.5s infinite",
  borderRadius: 6,
};

export const skeletonCard: React.CSSProperties = {
  ...card,
  padding: 20,
  display: "flex",
  flexDirection: "column",
  gap: 8,
};
